import React, { useEffect, useState } from "react";
import { Modal, Box, IconButton, Button } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

interface DocumentViewerProps {
  handleClose: () => void;
  documentUrl: string;
  // fileType?: string;
}

const DocumentViewer: React.FC<DocumentViewerProps> = ({
  handleClose,
  documentUrl,
  // fileType,
}) => {

  const [finalFileType, setFinalFileType] = useState("")


  useEffect(() => {

    const fetchBlobType = async () => {
      const response = await fetch(documentUrl);
      const blob = await response.blob();
      setFinalFileType(blob.type);
    };
    if (!documentUrl || documentUrl.split("?")[0].match(/\.(jpg|jpeg|png|gif|pdf)$/i)) {
      return;
    }
    fetchBlobType();
  }, [documentUrl]);

  if (!documentUrl) {
    return null;
  }

  const finalUrlFile = documentUrl.split("?")[0];
  console.log(finalUrlFile)
  console.log(finalFileType)

  return (
    <Modal open={true} onClose={handleClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "95%",
          height: "95%",
          bgcolor: "background.paper",
          boxShadow: 24,
          p: 2,
          overflow: "hidden",
          borderRadius: 2,
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Box
            sx={{
                textAlign: "center",
                mb: 2,
            }}
        >
            <IconButton
                onClick={handleClose}
                sx={{
                position: "absolute",
                top: 1,
                right: 8,
                zIndex: 10,
                mb: 1,
                }}
            >
                <CloseIcon />
            </IconButton>
        </Box>
        <Box
          sx={{
            flex: 1,
            overflow: "auto",
          }}
        >
          {finalUrlFile?.endsWith(".pdf") || finalFileType === "application/pdf" ? (
            <iframe
              src={documentUrl}
              width="100%"
              height="100%"
              title="PDF Viewer"
            ></iframe>
          ) : finalUrlFile?.match(/\.(jpg|jpeg|png|gif)$/i) || finalFileType?.startsWith("image/") ? (
            <img
              src={documentUrl}
              alt="Preview"
              style={{ width: "100%", height: "auto" }}
            />
          ) : (
            <></>
          )}
        </Box>
        <Box
          sx={{
            textAlign: "center",
            mt: 1,
          }}
        >
          <Button variant="contained" color="primary" onClick={handleClose}>
            Cerrar
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default DocumentViewer;
